import { BehaviorSubject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';

export type ConfigSection =
    | 'parsers'
    | 'online'
    | 'importPublicationTypeMapping'
    | 'importDocumentTypeMapping'
    | 'outputCitationTypeMapping'
    | 'icons'
    | 'biblioTables';

export type Config = {
    [key in ConfigSection]?: any;
};

export class Config$ {
    importedPublicationTypeMap = new Map<string, string>();

    // https://en.wikipedia.org/wiki/RIS_%28file_format%29
    importedDocumentTypeMap = new Map<string, string>();

    // https://docs.citationstyles.org/en/stable/specification.html
    exportCitationTypeMap = new Map<string, string>();

    biblioTablesMap = new Map<string, any[]>();

    constructor(private coords: CoordinatorService) {}

    private _config$ = new BehaviorSubject<Config | null>(null);
    config$ = this._config$.asObservable();

    private _configureBiblioTables(bt: { [tag: string]: { include?: string[]; itemLs?: any[] } }) {
        Object.keys(bt).forEach((k) => {
            if (k.startsWith('_')) return;
            const ls: any[] = [];
            const p = bt[k];
            p.include?.forEach((tag) => ls.push(...(bt[tag].itemLs || [])));
            p.itemLs && ls.push(...p.itemLs);
            ls.sort((a, b) => (b.weight || 0) - (a.weight || 0));
            this.biblioTablesMap.set(k, ls);
        });
    }

    biblioTable(tag: string) {
        const btId = `biblio-${tag}`;
        return {
            id: btId,
            pinId: btId,
            isGlobalEdit: true,
            hideEmpty: true,
            tagLs: this.biblioTablesMap.get(tag) || [],
        };
    }

    setConfig(config: Config) {
        this._config$.next(config);
        const iptm = config.importPublicationTypeMapping;
        iptm && (this.importedPublicationTypeMap = new Map(Object.entries(iptm)));

        const ipdm = config.importDocumentTypeMapping;
        ipdm && (this.importedDocumentTypeMap = new Map(Object.entries(ipdm)));

        const octm = config.outputCitationTypeMapping;
        octm && (this.exportCitationTypeMap = new Map(Object.entries(octm)));

        const icons = config.icons;
        this.coords.display$.icons = new Map(Object.entries(icons || {}));

        const bt = config.biblioTables;
        bt && this._configureBiblioTables(bt);

        if (config.parsers) {
            this.coords.worker$.parser.directPost({
                action: 'config',
                payload: { config: config.parsers },
            });
        }

        if (config.online) {
            this.coords.worker$.online.directPost({
                target: 'config',
                payload: { config: config.online },
            });
        }
    }
}
